import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.logo)
    ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.logo,
        alt: "logo",
        height: "32"
      }, null, 8, _hoisted_1))
    : _createCommentVNode("", true)
}